<section class="cpe">
  <router-outlet />
</section>
